/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { AssetStoryblok, MultiassetStoryblok } from '@/lib/storyblok/types/generated-types'

/**
 * Obtain the dimensions of an image asset by parsing the filename, which contains the dimensions of the image.
 *
 * @param asset - the asset to obtain the dimensions of
 */
const getAssetImageDimensions = (
  asset: AssetStoryblok | MultiassetStoryblok[number],
): { width: number; height: number } => {
  const dimensions = {
    width: asset.filename.split('/')[5].split('x')[0],
    height: asset.filename.split('/')[5].split('x')[1],
  }

  return {
    width: parseInt(dimensions.width),
    height: parseInt(dimensions.height),
  }
}

export { getAssetImageDimensions }
